module.exports = __webpack_public_path__ + "static/img/ranking2.52404e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/ranking2.png
// module id = /ecQ
// module chunks = 1